export const buildCarriersData = (towerLayers) => {
  const carrierMap = {};

  (towerLayers ?? []).forEach((layer) => {
    (layer?.shares ?? []).forEach((share) => {
      if (share?.carrier) {
        const carrier = String(share.carrier).trim();
        if (!carrierMap[carrier]) {
          carrierMap[carrier] = {
            carrier,
            totalLimit: 0,
            totalPremium: 0,
          };
        }
        carrierMap[carrier].totalLimit += share.shareOfLimit || 0;
        carrierMap[carrier].totalPremium += share.shareOfGrossPremium || 0;
      }
    });
  });

  const carriersData = Object.values(carrierMap);

  return carriersData;
};
